import $ from 'jquery';

var MostOrdered = {
    init: function () {
        this.mostOrderSubmit();
    },

    mostOrderSubmit: function () {
        $('body').on('change', '.most-ordered__products-filters-title #products-per-page', function(e) {
            e.preventDefault();
            window.location = $('#most-ordered-location').val() + '?per_page=' + $('#products-per-page option:selected').val();
        });
    },


}

export default MostOrdered;
